import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { Helmet } from '@xing-com/crate-helmet';

import {
  isBreakpointReference,
  mediaQueryByBreakpoint,
} from '../../utils/cover-media';

export const CoverMediaHeader: React.FC = () => {
  const { pageContext } = usePageContext();

  const { coverImage } = pageContext;

  if (!coverImage || coverImage.length === 0) {
    return null;
  }

  return (
    <Helmet>
      {coverImage
        .map((image) => {
          if (!image?.url) {
            return null;
          }

          const media =
            image.reference && isBreakpointReference(image.reference)
              ? mediaQueryByBreakpoint[image.reference]
              : undefined;

          return (
            <link
              key={image.reference ?? image.url}
              rel="preload"
              href={image.url}
              as="image"
              {...(media ? { media } : {})}
            />
          );
        })
        .filter(Boolean)}
    </Helmet>
  );
};
